import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SETTINGS_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { SettingsComponent } from './settings/settings.component';

const routes: Routes = [
  {
    path: SETTINGS_ROUTE,
    component: SettingsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
